export default __webpack_public_path__ + "static/media/tocaya.2d3e47c3.png";